import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorPage } from '@guildeducationinc/recess';
import { useCurrentClient } from '@src/hooks/useCurrentClient';
import { IntlContext, useLocale } from 'pe-core-frontend';
import { useContext, useEffect } from 'react';
// TODO: CLIENT_OPTIONAL_PATHS is for future implementation of MG-1831 (single EP, multiple clients for MPR)
// Paths that don't require a valid client context, e.g., '/auth/select-client'
const CLIENT_OPTIONAL_PATHS = [];
const isClientOptionalPath = () => CLIENT_OPTIONAL_PATHS.some(path => window.location.pathname.endsWith(path));
export const ClientLocaleWrapper = ({ children }) => {
    const { setLocale } = useContext(IntlContext);
    const { currentClient, loading } = useCurrentClient();
    const { t } = useLocale();
    useEffect(() => {
        setLocale(currentClient?.clientConfig?.locale || 'en');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentClient]);
    if (loading) {
        return null;
    }
    // Show 404 for invalid client URLs (e.g., /na/foo123/auth/login).
    // This check must happen here because ClientLocaleWrapper wraps all routes,
    // so it runs before page components can trigger redirects that would mask the error.
    if (!currentClient && !isClientOptionalPath()) {
        return _jsx(ErrorPage, { goBack: () => window.history.back(), title: t('Page not found.') });
    }
    return children;
};
